import Vue from "vue";
import Router from "vue-router";
import { externalAuthenticationProviderUrl } from "@/common/config";

import Login from "@/views/Login";
import ExternalLoginCallback from "@/views/ExternalLoginCallback";

import configRoutes from "[envbyven]/js/routes";

const routerConfig = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      guest: true,
      layout: "empty-layout"
    }
  },
  {
    path: "/external-login-callback",
    name: "external_login_callback",
    component: ExternalLoginCallback,
    meta: {
      guest: true
    }
  },
  // Access denied
  {
    path: "/access-denied",
    name: "access_denied",
    component: () => import("@/views/AccessDenied"),
    meta: {
      guest: false
    }
  },
  {
    path: "/settings/machine_registration",
    name: "machine_registration",
    component: () => import("@/views/MachineRegistration"),
    meta: {
      requiresAuth: true,
      disableSearchMachineAndGroup: true,
      sidebar: "general_settings",
      addPageWithinSidebar: false
    }
  },
  {
    path: "/settings/user-mgmt",
    name: "user_management",
    component: () => import("@/views/UserManagement"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-users_management.png"),
      addPageWithinSidebar: true,
      requiresRoles: [
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/machine-settings",
    name: "machine_settings",
    component: () => import("@/views/MachineSettings"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      requiresRoles: [
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/organization",
    name: "organization_settings",
    component: () => import("@/views/OrganizationSettings"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-factory.png"),
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true,
      requiresRoles: [
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ]
    }
  },
  {
    path: "/settings/machine-activation",
    name: "machine_activation",
    component: () => import("@/views/MachineActivations"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/machine-single-settings",
    name: "machine_single_settings",
    component: () => import("@/views/MachineSingleSettings"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/machine-shifts",
    name: "machine_shifts",
    component: () => import("@/views/MachineShifts"),
    meta: {
      requiresAuth: true,
      sidebar: "general_settings",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      requiresRoles: [
        { Label: "manager_di_linea" },
        { Label: "vendor_user" },
        { Label: "sales_dealer_role" },
        { Label: "service_dealer_role" },
        { Label: "digital_service_manager" },
        { Label: "branch_user" },
        { Label: "branch_manager" }
      ],
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/profile",
    name: "user_profile",
    component: () => import("@/views/UserProfile"),
    meta: {
      requiresAuth: true,
      sidebar: "settings",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/settings/notifications",
    name: "notify_management",
    component: () => import("@/views/Notifications"),
    meta: {
      requiresAuth: true,
      sidebar: "settings",
      ico: require("@/assets/images/menu-alarm.png"),
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true
    }
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("@/views/Documentation"),
    meta: {
      layout: "only-header-layout",
      requiresAuth: true,
      mdParent: true
    }
  },
  {
    path: "/subscriptions-management/software-upgrade",
    name: "software_upgrade",
    component: () => import("@/views/SoftwareUpgrade"),
    meta: {
      requiresAuth: true,
      sidebar: "subscriptions-management",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true,
      clearQuerySideNav: true
    }
  },
  {
    path: "/subscriptions-management/machine-activation",
    name: "machine-subscription",
    component: () => import("@/views/MachineSubscription"),
    meta: {
      requiresAuth: true,
      sidebar: "subscriptions-management",
      ico: require("@/assets/images/menu-machine_settings.png"),
      addPageWithinSidebar: true,
      disableSearchMachineAndGroup: true,
      clearQuerySideNav: true
    }
  },
  {
    path: "/faq/:lang/troubleshooting",
    name: "troubleshooting",
    component: () => import("@/views/Documentation"),
    meta: {
      layout: "only-header-layout",
      requiresAuth: true,
      defaultFile: `/en-US/faq/troubleshooting`,
      mdFile: "/$LANG/faq/troubleshooting"
    }
  },
  // Page not found
  {
    path: "*",
    redirect: { name: "login" }
  }
];

Vue.use(Router);

const fullConfig = {
  routes: [...routerConfig, ...configRoutes],
  mode: "history"
};

const router = new Router(fullConfig);

router.beforeEach((to, from, next) => {
  window.document.title = to.meta && to.meta.title ? to.meta.title : process.env.VUE_APP_TITLE;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("refreshToken") === null) {
      if (to.query.externalLogin !== "true") {
        next({ path: "/login", query: { redirect_uri: to.fullPath } });
      } else {
        const currentUrl = `?redirect_uri=${encodeURIComponent(
          window.location.origin + to.fullPath
        )}`;

        const externalLoginUrl = `${externalAuthenticationProviderUrl}sso?redirect_uri=${encodeURIComponent(
          window.location.origin + "/external-login-callback" + currentUrl
        )}`;

        window.location.href = externalLoginUrl;

        next(false);
      }
    } else {
      history.pushState(null, "", to.fullPath);

      next();
    }
  } else {
    history.pushState(null, "", to.fullPath);

    next();
  }
});

export default router;
